/**
 * Access token lives in a JS variable.
 * sessionStorage is tab memory for short sessions (F5) — never localStorage.
 */

const SESSION_KEY = 'ezts_access_token';

let accessToken = null;
const listeners = new Set();

function readSessionToken() {
  try {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage.getItem(SESSION_KEY);
  } catch {
    return null;
  }
}

function writeSessionToken(token) {
  try {
    if (typeof sessionStorage === 'undefined') return;
    if (token) sessionStorage.setItem(SESSION_KEY, token);
    else sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // ignore
  }
}

export const accessTokenStore = {
  get() {
    return accessToken;
  },

  /**
   * Reload helper: short session keeps the JWT in sessionStorage.
   */
  restoreFromSession() {
    if (accessToken) return accessToken;
    const fromSession = readSessionToken();
    if (fromSession) {
      accessToken = fromSession;
      listeners.forEach((listener) => listener(accessToken));
    }
    return accessToken;
  },

  /**
   * @param {string|null} token
   * @param {{ persistSession?: boolean }} [options]
   * persistSession true  → also sessionStorage (short session F5)
   * persistSession false → clear sessionStorage
   * omitted → update memory only; leave sessionStorage alone
   */
  set(token, { persistSession } = {}) {
    accessToken = token || null;
    if (persistSession === true && accessToken) {
      writeSessionToken(accessToken);
    } else if (persistSession === false || !accessToken) {
      writeSessionToken(null);
    }
    listeners.forEach((listener) => listener(accessToken));
  },

  clear() {
    accessToken = null;
    writeSessionToken(null);
    listeners.forEach((listener) => listener(null));
  },

  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
